import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { usePayoutDividendsMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Form as FormLayout } from "react-bootstrap";
import TextInput from "../../../Common/components/text-input";
import DateInput from "../../../Common/components/date-input";
import Skeleton from "react-loading-skeleton";

const PayoutDividendsModal = ({ showPayoutDividendsModal, assetId, symbol, onHide }) => {

    const [
        payoutDividends,
        {
            isLoading,
        }
    ] = usePayoutDividendsMutation()

    const validationSchema = Yup.object({
        amountPerShare: Yup.number().min(0.0).required('Required'),
        qualificationDate: Yup.date().required('Required')
    })

    return (
        <Modal
            show={showPayoutDividendsModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
        >
            <Formik
                initialValues={{
                    amountPerShare: 0.0,
                    qualificationDate: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    payoutDividends({ assetId, ...values })
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Dividends Payment Initiated Successfully")
                            onHide()
                        })
                }}
            >
                {
                    ({ isValid }) => (
                        <Form>
                            <Modal.Header>
                                <Modal.Title id="contained-modal-title-vcenter">
                                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                                        <SVG
                                            title=""
                                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Safe.svg")}
                                        />
                                    </span>
                                    Payout {symbol ? symbol : <div style={{ width: "100px" }}><Skeleton count="1" /></div>} Dividends
                                </Modal.Title>
                                <button type="button" className="close" onClick={onHide}>
                                    <span aria-hidden="true" className="d-block">×</span>
                                    <span className="sr-only">Close</span>
                                </button>
                            </Modal.Header>
                            <Modal.Body
                                className="px-10 py-2"
                            >
                                <fieldset disabled={isLoading}>
                                    <FormLayout.Row>
                                        <TextInput
                                            label="Amount Per Share*"
                                            name="amountPerShare"
                                            type="number"
                                            step="any"
                                            min="0.0"
                                        />
                                        <DateInput
                                            label="Qualification Date*"
                                            name="qualificationDate"
                                        />
                                    </FormLayout.Row>
                                </fieldset>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    type="button"
                                    onClick={onHide}
                                    className="btn btn-light btn-elevate px-4"
                                    disabled={isLoading}
                                >
                                    Close
                                </button>
                                <> </>
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-elevate px-4 ml-4"
                                    disabled={isLoading || !isValid}
                                >
                                    Payout Dividends
                                </button>
                            </Modal.Footer>
                        </Form>
                    )}
            </Formik>
        </Modal>
    );
}

export default PayoutDividendsModal;